import { CustomDestination } from '../Avo';

/**
 * Google Tag Manager: dataLayer
 * The data layer is an object used by Google Tag Manager and gtag.js to pass
 * information to tags. Events or variables can be passed via the data layer,
 * and triggers can be set up based on the values of variables.
 *
 * https://developers.google.com/tag-platform/tag-manager/web/datalayer
 */

const GTM: CustomDestination = {
  logEvent: (eventName, eventProperties) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventProperties,
    });
  },

  setUserProperties: (userId: string, userProperties: object) => {
    window.dataLayer.push({
      user_id: userId,
      ...userProperties,
    });
  },

  identify: (userId: string) => {
    window.dataLayer.push({
      user_id: userId,
    });
  },

  unidentify: () => {
    window.dataLayer.push({
      user_id: null,
    });
  },
};

export default GTM;
